const actions = {
  setAssinaturaCadastrarCartao({ commit }, payload) {
    commit('SET_ASSINATURA_CADASTRAR_CARTAO', payload);
  },

  // Intenção de recobrar após cadastrar cartão (setada ANTES do save; não dispara nada sozinha).
  setRecobrarAposCadastro({ commit }, payload) {
    commit('SET_RECOBRAR_APOS_CADASTRO', payload);
  },

  // Recobrança ARMADA (compraId): consumida pelo Card na lista. Setada só após o save confirmado.
  setAssinaturaRecobrar({ commit }, payload) {
    commit('SET_ASSINATURA_RECOBRAR', payload);
  },
};

const mutations = {
  /* eslint-disable no-param-reassign */
  SET_ASSINATURA_CADASTRAR_CARTAO(state, payload) {
    state.assinaturaCadastrarCartao = payload;
  },

  SET_RECOBRAR_APOS_CADASTRO(state, payload) {
    state.recobrarAposCadastro = payload;
  },

  SET_ASSINATURA_RECOBRAR(state, payload) {
    state.assinaturaRecobrar = payload;
  },
  /* eslint-enable no-param-reassign */
};

const state = {
  assinaturaCadastrarCartao: false,
  recobrarAposCadastro: null,
  assinaturaRecobrar: null,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
